/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { AssetListRefreshRunDto } from './AssetListRefreshRunDto';
import type { DatasourceWithIngestionRun } from './DatasourceWithIngestionRun';

export type IntegrationIngestionRunDto = {
    datasourcesWithIngestionRun: Array<DatasourceWithIngestionRun>;
    id: string;
    integrationName: string;
    integrationType: IntegrationIngestionRunDto.integrationType;
    lastAssetListRefreshRun?: AssetListRefreshRunDto;
    lastSuccessfulAssetListRefreshRun?: AssetListRefreshRunDto;
};

export namespace IntegrationIngestionRunDto {

    export enum integrationType {
        ATHENA = 'ATHENA',
        BIGQUERY = 'BIGQUERY',
        REDSHIFT = 'REDSHIFT',
        SNOWFLAKE = 'SNOWFLAKE',
        DATABRICKS = 'DATABRICKS',
        MSSQL = 'MSSQL',
        MYSQL = 'MYSQL',
        POSTGRES = 'POSTGRES',
        ORACLE = 'ORACLE',
        SYNAPSE = 'SYNAPSE',
        LOOKER = 'LOOKER',
        POWER_BI = 'POWER_BI',
        QUICKSIGHT = 'QUICKSIGHT',
        TABLEAU = 'TABLEAU',
        MICROSTRATEGY = 'MICROSTRATEGY',
        QLIK = 'QLIK',
        AIRFLOW = 'AIRFLOW',
        MWAA = 'MWAA',
        COMPOSER = 'COMPOSER',
        DBT = 'DBT',
        DBTCLOUD = 'DBTCLOUD',
        FIVETRAN = 'FIVETRAN',
        ADF = 'ADF',
        DATABRICKS_JOBS = 'DATABRICKS_JOBS',
        ATLAN = 'ATLAN',
        DECLARATIVE = 'DECLARATIVE',
        _UNKNOWN_ = '_UNKNOWN_',
    }


}
